export default __webpack_public_path__ + "static/media/flat-color.frag.fbc51e06.glsl";